import { CSSProperties } from "react";
import { LayerProps } from "react-laag";

import "../../styles/regex/RegexSuggestion.css";

export { RegexSuggestionList, SuggestionType, RegexSuggestion as Suggestion };

type SuggestionType = {
  label: string;
  regex: string;
};
type Props = {
  suggestions?: SuggestionType[];
  onClick(regex: string): void;
  layerProps: LayerProps;
  style: CSSProperties;
};

// FIXME: Add CSS class to handle suggestion with and without label
const RegexSuggestionList = (props: Props) => {
  let suggestions = props.suggestions;
  if (suggestions) {
    suggestions = [
      {
        label: "Any Validation Regex",
        regex: "$Valid",
      },
    ].concat(suggestions);
  }
  return (
    <div
      className={"RegexSuggestionsList"}
      {...props.layerProps}
      style={props.style}
    >
      {suggestions?.map((x, i) => (
        <RegexSuggestion
          key={i}
          label={x.label}
          regex={x.regex}
          onClick={() => props.onClick(x.regex)}
        />
      ))}
    </div>
  );
};

// FIXME: Add CSS class to handle suggestion with and without label
const RegexSuggestion = (props: SuggestionType & { onClick: VoidFunction }) => {
  const includeLabel = props.label.trim() !== "";
  return (
    <div className="RegexSuggestion" onClick={props.onClick}>
      {includeLabel && <label>{props.label}</label>}
      <p>{props.regex}</p>
    </div>
  );
};

// const RegexSuggestions = (props: Props) => {
//     const buttonRef = useRef<HTMLButtonElement | null | undefined>();

//     const {
//         renderLayer,
//         triggerProps,
//         layerProps,
//         arrowProps,
//         layerSide,
//         setOpen,
//         isOpen
//     } = useTooltip(
//         buttonRef,
//         () => {
//             setOpen(false)
//         },
//         // attach to button
//         disappearType => {
//             if (disappearType == 'full') {
//                 setOpen(false);
//             }
//         },
//         () => {
//             setOpen(false);
//         },
//     );

//     // TODO: useCallback and useState ?? https://medium.com/welldone-software/usecallback-might-be-what-you-meant-by-useref-useeffect-773bc0278ae
//     useEffect(() => {
//         // call react-laag triggerRef, otherwise error !
//         triggerProps?.ref(buttonRef.current);
//     }, [buttonRef, buttonRef?.current]);

//     return (
//         <>
//             <button {...triggerProps}
//                 ref={r => buttonRef.current = r}
//                 onClick={() => setOpen(!isOpen)}
//                 style={{
//                     display: (props.suggestions ?? []).length === 0 ? 'none' : 'initial'
//                 }}
//                 className={'regexSuggestions'}>

//                 <Icon altText={'View Regex Suggestions'} icon={'chevron-down'} />

//             </button>

//             {isOpen &&
//                 renderLayer(
//                     <div
//                         {...layerProps}
//                         style={{
//                             ...layerProps.style,
//                             // add merge properties here
//                         }}
//                         className={'tooltip ' + layerSide}>
//                         <div style={{
//                             display: 'flex',
//                             flexDirection: 'column',
//                             overflowY: 'auto',
//                             maxHeight: '8rem',
//                         }}>
//                             <RegexSuggestionList onClick={props.onClick} suggestions={props.suggestions} />
//                         </div>
//                         <Arrow className={'arrow ' + layerSide} {...arrowProps} size={5} roundness={0} />
//                     </div>
//                 )}
//         </>
//     )
// }
